// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3B7cM","search":"Settings_search__HEGU3","filter":"Settings_filter__QJFvS"};